module.exports = __webpack_public_path__ + "static/img/1.950515f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/zh/1.png
// module id = aOlV
// module chunks = 0